import React, { useEffect, useState } from "react";
import Player from "../player";
import Map from "../map";
import API from "../../utils/API";
import { useHistory, useParams } from "react-router-dom";
import MusicBtn from "../../components/SoundBtns/MusicBtn";
import { LakeBed } from "../../data/maps/1";
import store from "../../config/store";
import { resolveStageEntrySpawn, prepareConnectedTransition } from "../../config/worldTransitions";

function LakeBedWorld(props) {
  const { id } = useParams();
  const history = useHistory();
  const [initialPosition] = useState(() => resolveStageEntrySpawn(id, "lake-bed", props.initialPosition));

  useEffect(() => {
    store.dispatch({ type: "ADD_TILES", payload: { tiles: LakeBed } });
    API.UpdateSpritePlace("lake-bed", id).catch(() => {});
  }, [id]);

  const leaveLakeBed = (position) => {
    const cell = [position[0] / 64, position[1] / 64];
    const direction = cell[0] === 0 ? "WEST" : cell[1] === 0 ? "NORTH" : "EAST";
    const transition = prepareConnectedTransition(id, "lake-bed", direction, cell);
    if (!transition) return;
    API.UpdateSpritePlace(transition.destination, id)
      .finally(() => history.push(transition.destination === "village" ? `/village/${id}` : `/dragon-cave/${id}`));
  };

  return (
    <div id="world-container" className="lake-bed-world" style={{ position: "relative", width: "968px", top: "35%", marginLeft: "3px", border: "4px solid black", borderRadius: "5px" }}>
      <MusicBtn />
      <Map />
      <Player avatar={props.avatar} avatarName={props.avatarName} initialPosition={initialPosition}
        exitZones={{ WEST: [[0, 7]], NORTH: [[9, 0]] }} onRightEdge={leaveLakeBed}
        npcMessages={{
          370: "A lakeside ranger adjusts their pack. 'The western trail returns to the Village.' ",
          371: "A fisher gestures toward the dock. 'The water is calm today, but the cave path feels different.' ",
          372: "A traveler studies the rocks. 'Something large is sleeping beyond that dark opening.' ",
          379: "Vinnie studies the cave entrance. 'Only the brave should enter. Keep your eyes open in the dark.' ",
        }} />
    </div>
  );
}

export default LakeBedWorld;
